import { Component } from "react"
import PropTypes from "prop-types"
import { isNull } from "lodash"
import UploadScanPreview from "modules/upload-scan-preview"
import Upload from "components/upload"
import UploadHeader from "components/upload/components/upload-header"
import UploadContainer from "components/upload/components/upload-container"
import UploadStep from "components/upload/components/upload-step"
import Stepper from "components/stepper"
import "./style.scss"

export default class ExperimentPositions extends Component {
  static propTypes = {
    params: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    addNotification: PropTypes.func.isRequired,
    account: PropTypes.string.isRequired,
    resetUpload: PropTypes.func.isRequired,
    scanFiles: PropTypes.func.isRequired,
    files: PropTypes.array.isRequired,
    uploadOption: PropTypes.string.isRequired,
    activeStep: PropTypes.number.isRequired,
    confirmUpload: PropTypes.func.isRequired,
    steps: PropTypes.array.isRequired,
    addFiles: PropTypes.func.isRequired,
    removeFile: PropTypes.func.isRequired,
    uploadConfig: PropTypes.object.isRequired,
    scanResult: PropTypes.object,
    resetScan: PropTypes.func.isRequired,
    changeUploadOption: PropTypes.func.isRequired,
    uploadDateTime: PropTypes.object,
    uploadedFiles: PropTypes.array.isRequired,
    overlappingDates: PropTypes.array.isRequired,
    resourceInfo: PropTypes.object,
    setModel: PropTypes.func.isRequired,
    models: PropTypes.array.isRequired,
    modelId: PropTypes.string.isRequired,
    experiment: PropTypes.object.isRequired,
  }

  onSubmit = () => {
    const { scanFiles, files, uploadOption, activeStep, confirmUpload, experiment } = this.props

    switch (activeStep) {
      case 0:
        scanFiles(files, experiment.resourceId)
        break
      case 1:
        confirmUpload(uploadOption, experiment.resourceId)
        break
    }
  }

  goToHome = () => {
    const { navigate, account } = this.props
    navigate(`/${account}/home/resources`)
  }

  setModel = (ev) => {
    const { setModel } = this.props
    setModel(ev.target.value)
  }

  render() {
    const {
      params,
      navigate,
      addNotification,
      overlappingDates,
      files,
      uploadedFiles,
      scanResult,
      uploadOption,
      uploadDateTime,
      uploadConfig,
      activeStep,
      steps,
      addFiles,
      removeFile,
      resetScan,
      changeUploadOption,
      resourceInfo,
      models,
      modelId,
      experiment,
      resetUpload,
    } = this.props

    const rolloverLegend = `Alternative experiments will only be available in the research topic screen for ${resourceInfo.name}.`
    const legend = <>To upload as a portfolio that can be accessible everywhere, visit the <button onClick={this.goToHome}>OP Home Screen</button> and create a new portfolio</>

    let currentStep

    if (!params.step) {
      currentStep = <UploadStep
        addFiles={addFiles}
        files={files}
        removeFile={removeFile}
        addNotification={addNotification}
        uploadConfig={uploadConfig}
        docLink="https://support.ompnt.com/en/articles/78542-uploads-in-common-position-format"
        legend={legend}
      />
    } else if (params.step === "preview") {
      currentStep = <UploadScanPreview
        showOverrideOptions={!isNull(experiment.availableFrom)}
        overlappingDates={overlappingDates}
        target={{ model: modelId, name: resourceInfo.name }}
        uploadDateTime={uploadDateTime}
        type="experiment"
        scanResult={scanResult}
        resetScan={resetScan}
        uploadStep={steps[0]}
        changeUploadOption={changeUploadOption}
        uploadOption={uploadOption}
      />
    }

    return <Upload onCancel={resetUpload} className="upload-experiment">
      <UploadHeader
        type="Alternative Experiment"
        target={{ modelId, name: experiment.name }}
        rolloverLegend={rolloverLegend}
        models={models}
        setModel={this.setModel}
        editableModel={activeStep === 0}
      />
      <UploadContainer>
        <Stepper
          goBack={() => { navigate(-1) }}
          steps={steps}
          activeStep={activeStep}
          disableVariables={{ files, uploadOption, uploadedFiles, overlappingDates, type: "experiment" }}
          onSubmit={this.onSubmit}
          stepComponent={currentStep}
        />
      </UploadContainer>
    </Upload>
  }
}
